export function decimalToHexColorString(value: number): string {
    return '#' + ('00000' + Math.abs(value).toString(16)).substr(-6);
}

/**
 * Converts a color in the CSS format #xxxxxx or #xxxxxxxx to a color in the CSS format rgba(x, x, x, x)
 * Note that for now the CSS format #xxx is not supported
 * @param hex string in a valid CSS color format
 * @param alpha A value in the range [0-1] that will be used for the alpha channel if there is no alpha
 * information in the hex string value. Default value is 1.
 */
export function cssHexToCssRgba(hex: string, alpha: number = 1): string {
    if (hex[0] == "#" && (hex.length == 7 || hex.length == 9)) {
        // The end color of the gradient should be transparent and because older browsers do not support the
        // 32-bit color format "#XXXXXXXX we should use the rgba() function and convert the hex string to
        // values between 0 - 255

        let hexColorString = hex.replace('#', '0x')

        // if there is no alpha information in the string add alpha as a value
        if (hex.length == 7) {
            // clamp the alpha value to the range [0-1]
            alpha = Math.max(0, Math.min(1, alpha))

            let alphaString = Math.floor(alpha * 255).toString(16)
            if (alphaString.length == 1) {
                alphaString = `0${alphaString}`
            }

            hexColorString += alphaString
        }


        const rgbaColor = []
        const numberColor = parseInt(hexColorString)

        for (let i = 0; i < 4; i++) {
            rgbaColor[i] = (numberColor >> (24 - (i * 8))) & 0xff
        }

        return `rgba(${rgbaColor[0]},${rgbaColor[1]},${rgbaColor[2]},${rgbaColor[3] / 255})`
    }

    throw new Error(`${hex} is not a valid CSS color`)
}
